import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface PageBreadcrumbProps {
  items: Crumb[];
}

export default function PageBreadcrumb({ items }: PageBreadcrumbProps) {
  return (
    <nav className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-500 flex-wrap">
      {items.map((item, idx) => (
        <span key={idx} className="inline-flex items-center gap-1.5">
          {item.to ? (
            <Link
              to={item.to}
              className="hover:text-primary-600 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
          {idx < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-400" />
          )}
        </span>
      ))}
    </nav>
  );
}